const MARKETWATCH = {
  title: 'MarketWatch',
  value: 'marketwatch',
  gams: true,
  defaultGroups: ['Dynamic Insets/IFrames'],
  sizes: [
    {
      id: 'marketwatch-MG',
      gams: 'MG',
      label: 'MarketWatch MG',
      width: 569,
      height: 398,
      interactive: false,
      scale: 2,
      target: 'marketwatch',
      publish: 'image',
      group: 'Images',
    },
    {
      id: 'marketwatch-ZT',
      OR: true,
      gams: 'ZT',
      label: 'MarketWatch ZT',
      width: 200,
      height: 112,
      interactive: false,
      scale: 2,
      target: 'marketwatch',
      publish: 'image',
      group: 'Images',
    },
    {
      id: 'marketwatch-ZH',
      gams: 'ZH',
      label: 'MarketWatch ZH',
      width: 890,
      height: 501,
      interactive: false,
      scale: 2,
      target: 'marketwatch',
      publish: 'image',
      group: 'Images',
    },
    {
      id: 'marketwatch-ZG',
      label: 'MarketWatch ZG',
      gams: 'ZG',
      width: 660,
      height: 371,
      interactive: false,
      scale: 2,
      target: 'marketwatch',
      publish: 'image',
      group: 'Images',
    },
    {
      id: 'thumb-marketwatch-MA',
      gams: 'MA',
      label: 'MarketWatch MA',
      width: 86,
      height: 86,
      interactive: false,
      scale: 2,
      target: 'marketwatch',
      publish: 'image',
      group: 'Thumbnails',
    },
    {
      id: 'marketwatch-ZR',
      gams: 'ZR',
      label: 'MarketWatch ZR',
      width: 115,
      height: 65,
      interactive: false,
      scale: 2,
      target: 'marketwatch',
      publish: 'image',
      group: 'Images',
    },
    {
      id: 'marketwatch-ZQ',
      gams: 'ZQ',
      label: 'MarketWatch ZQ',
      width: 660,
      height: 371,
      interactive: false,
      scale: 1,
      target: 'marketwatch',
      publish: 'image',
      group: 'Images',
    },
    {
      id: 'marketwatch-4u-inset',
      label: 'Inset Mobile',
      width: 300,
      height: 400,
      minWidth: 0,
      minHeight: 200,
      maxHeight: 3000,
      interactive: true,
      scale: 2,
      target: 'marketwatch',
      publish: 'inset',
      group: 'Dynamic Insets/IFrames',
    },
    {
      id: 'marketwatch-8u-inset',
      label: 'Inset MG', // header/inline/offset',
      width: 620,
      height: 434,
      minWidth: 360,
      minHeight: 200,
      maxHeight: 3000,
      interactive: true,
      scale: 1,
      target: 'marketwatch',
      publish: 'inset',
      group: 'Dynamic Insets/IFrames',
    },
    {
      id: 'marketwatch-12u-inset',
      label: 'Inset ZH', // bleed',
      width: 940,
      height: 505,
      minWidth: 621,
      minHeight: 200,
      maxHeight: 3000,
      interactive: true,
      scale: 1,
      target: 'marketwatch',
      publish: 'inset',
      group: 'Dynamic Insets/IFrames',
    },
    {
      id: 'marketwatch-thumb',
      label: 'Thumb',
      width: 300,
      height: 169,
      minWidth: 0,
      minHeight: 169,
      maxHeight: 169,
      interactive: true,
      scale: 1,
      target: 'marketwatch',
      publish: 'inset',
      group: 'Dynamic Insets/IFrames',
    },
    // {
    //   id: 'marketwatch-16u-inset',
    //   label: '16U Preview',// bleed',
    //   width: 1260,
    //   height: 945,
    //   minWidth: 941,
    //   minHeight: 200,
    //   maxHeight: 3000,
    //   interactive: true,
    //   scale: 1,
    //   target: 'marketwatch',
    //   publish: 'inset',
    //   group: 'Dynamic Insets/IFrames',
    // },
  ],
};

export const FALLBACK_SIZE = 'marketwatch-4u-inset';

export const STYLES =
  '\n@import url("https://fonts.googleapis.com/css2?family=Lato:wght@400;700;900&family=Mulish:wght@400;800&display=swap");';

export default MARKETWATCH;
